// extracted by mini-css-extract-plugin
export default {"autoContainers":"style_autoContainers__5j7sn","directorsBlock":"style_directorsBlock__L4++F","directorsDetail":"style_directorsDetail__lf9Jh"};